import { Route, Routes, useLocation } from 'react-router-dom';
import { WorkPage } from '../WorkPage/WorkPage';
import { BusinessPage } from '../BusinessPage/BusinessPage';
import { useEffect } from 'react';
import { useContextNavigate } from '../../hooks/navigate';
import { AppContext } from '../../components/Menu/MenuButton';

export enum OfficeContext {
    Work = 'work',
    Business = 'business',
}

export const OfficeRoutes = () => {
    const navigate = useContextNavigate<OfficeContext>();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === `/${AppContext.Office}`) {
            navigate(OfficeContext.Work, { replace: true, state: location.state });
        }
    }, [location.pathname, location.state, navigate]);
    
    return (
        <Routes>
            <Route path={ `/${OfficeContext.Work}/*` } element={<WorkPage />} />
            <Route path={ `/${OfficeContext.Business}/*` } element={ <BusinessPage /> } />
        </Routes>
    );
};